//the api will retrieve the pending orders of this user. Feel free to change 
//it to try retrieving the orders of other customers.
//in the full website, this will likely be replaced by 
//context/redux and a full user validation suite.

const userId: string = "10595";

export default userId;